import { Link } from '@tanstack/react-router';
import { BuildingIcon } from 'lucide-react';

import { Card } from '@/components/ui/card';
import { PROPERTY_LEVELS } from '@/constants/property-level';
import { EstateImage } from '@/features/estates-property/components/estate-image';

import { EstateInfo, type EstateInfoProps } from './estate-info';

export type EstateCardProps = EstateInfoProps & {
  thumbnailId?: string | null;
  btnActionRender?: (props: EstateInfoProps) => JSX.Element | null;
};

export const EstatesGridCard = ({ ...props }: EstateCardProps) => {
  const params =
    props.propertyLevel === PROPERTY_LEVELS.PROJECT
      ? { projectId: props.id, estateId: '' }
      : { estateId: props.id, projectId: '' };
  const linkTo =
    props.propertyLevel === PROPERTY_LEVELS.PROJECT ? '/projects/$projectId' : '/estates/$estateId';

  return (
    <Link to={linkTo} params={params}>
      <Card className="h-full min-h-[522px]">
        <div className="relative">
          {props.propertyLevel === PROPERTY_LEVELS.PROJECT ? (
            <BuildingIcon
              size={30}
              className="absolute left-[10px] top-[10px] text-[hsl(var(--primary-color-light))]"
            />
          ) : null}
          <EstateImage {...(props.thumbnailId && { thumbnailId: props.thumbnailId })} />
          {props.btnActionRender ? props.btnActionRender(props) : null}
        </div>
        <EstateInfo {...props} />
      </Card>
    </Link>
  );
};
